// Lightweight, browser-only tutorial state. No backend / DB changes — keeps
// beta data untouched. Keyed per user id so different accounts on one device
// keep their own progress.

const keyFor = (userId, suffix) => `rw_tutorial_${userId || 'anon'}_${suffix}`;

const readJSON = (k, fallback) => {
  try {
    const v = localStorage.getItem(k);
    return v ? JSON.parse(v) : fallback;
  } catch {
    return fallback;
  }
};

const writeJSON = (k, val) => {
  try {
    localStorage.setItem(k, JSON.stringify(val));
  } catch {
    /* storage may be unavailable (private mode) — fail quietly */
  }
};

export function getTourState(userId) {
  return readJSON(keyFor(userId, 'tour'), {
    completed: false,
    skipped: false,
    lastSeenAt: null,
  });
}

export function setTourState(userId, patch) {
  const next = { ...getTourState(userId), ...patch };
  writeJSON(keyFor(userId, 'tour'), next);
  return next;
}

// True only for users who have never opened or dismissed the tour.
export function shouldAutoOpenTour(userId) {
  const s = getTourState(userId);
  return !s.completed && !s.skipped && !s.lastSeenAt;
}

export function resetTour(userId) {
  writeJSON(keyFor(userId, 'tour'), { completed: false, skipped: false, lastSeenAt: null });
}

// Getting Started checklist — dismissal + UI-only "reviewed Field View" step.
export function isChecklistDismissed(userId) {
  return readJSON(keyFor(userId, 'checklist_dismissed'), false) === true;
}
export function setChecklistDismissed(userId, val) {
  writeJSON(keyFor(userId, 'checklist_dismissed'), !!val);
}

export function isFieldViewReviewed(userId) {
  return readJSON(keyFor(userId, 'fieldview_reviewed'), false) === true;
}
export function markFieldViewReviewed(userId) {
  writeJSON(keyFor(userId, 'fieldview_reviewed'), true);
}
